import EmployeeCurrentRates from "./EmployeeCurrentRates";

export default EmployeeCurrentRates;
